<template>
  <div>
    <div class="yncontainer">
      <div class="statbar">
        <div
          v-for="(v, k) in loop"
          :key="k"
          class="bar"
          :class="[k]"
          :title="`${v} - ${percentage(k)}%`"
          :style="{ width: `${percentage(k)}%` }"
        >
          <span>{{ percentageStr(k) }}%</span>
        </div>
      </div>

      <div class="bars" style="height: auto;">
        <li class="stat-item" v-for="(v, k) in loop" :key="k">
          <div class="lefttext">
            <span>{{ v }}</span>
          </div>

          <div class="percentages">
            <span :class="[k]" :style="{ width: `${percentage(k)}%` }"></span>
          </div>

          <span class="percentagespan"
            >{{ answer(k).count }} ({{ percentageStr(k) }}%)</span
          >
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import ReportingQuestionMixin from '@/app/mixins/ReportingQuestionMixin';

export default {
  name: 'YesNo',
  mixins: [ReportingQuestionMixin],

  data() {
    return {
      opened: true,
    };
  },
};
</script>

<style lang="scss" scoped>
$c-no: #1b75bc;
$c-yes: #854b9d;
$c-alt: #faad41;
$c-unsure: #f04e33;
$c-skipped: #00aaa8;

.yncontainer {
  position: relative;
  width: 100%;
  margin-top: 0;
  margin-bottom: 30px;
  padding: 35px 15px 15px;
  background: #ebebec;
  transition: padding 0.25s ease-in-out;

  .statbar {
    display: flex;
    flex-wrap: nowrap;
    position: absolute;
    width: 100%;
    height: 25px;
    overflow: hidden;
    top: 0;
    left: 0;

    .bar {
      display: inline-block;
      padding: 2px 0;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: white;

      &.no {
        background-color: $c-no;
      }
      &.yes {
        background-color: $c-yes;
      }
      &.alt {
        background-color: $c-alt;
      }
      &.unsure {
        background-color: $c-unsure;
      }
      &.skipped {
        background-color: $c-skipped;
      }
    }
  }

  .bars {
    transition: height 0.25s ease-in-out;
    overflow: hidden;

    .stat-item {
      display: flex;
      width: 100%;
      margin-bottom: 0;
      margin-bottom: 4px;
      font-size: 12px;

      > * {
        cursor: pointer;
        line-height: 20px;
      }

      .lefttext {
        display: inline-block;
        flex: 2;
        text-align: left;
        vertical-align: middle;
        padding: 0 10px 0 0;
      }

      .percentages {
        display: inline-block;
        position: relative;
        background: 0 0;
        border-radius: 10px;
        border: 0.8px solid #8b8b8b;
        overflow: hidden;
        flex: 7;
        margin: 5px 0;
        height: 8px;

        span {
          display: block;
          position: absolute;
          top: 0px;
          height: 6px;
          background-color: #3a87a3;

          &.no {
            background-color: $c-no;
          }

          &.yes {
            background-color: $c-yes;
          }

          &.alt {
            background-color: $c-alt;
          }

          &.unsure {
            background-color: $c-unsure;
          }

          &.skipped {
            background-color: $c-skipped;
          }
        }
      }

      .percentagespan {
        display: flex;
        padding: 0 5px;
        flex: 2;
      }
    }
  }
}
</style>
